import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendBackwards = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			clipRule: "evenodd",
			d: "M12 24H20C22.2667 24 24 22.2667 24 20V12C24 9.73333 22.2667 8 20 8H12C9.73333 8 8 9.73333 8 12V20C8 22.2667 9.73333 24 12 24ZM10.6667 12C10.6667 11.2 11.2 10.6667 12 10.6667H20C20.8 10.6667 21.3333 11.2 21.3333 12V20C21.3333 20.8 20.8 21.3333 20 21.3333H12C11.2 21.3333 10.6667 20.8 10.6667 20V12Z"
		}), /* @__PURE__ */ _jsx("path", { d: "M6.66667 13.3333V16H3.6C1.6 16 0 14.4 0 12.4V3.6C0 1.6 1.6 0 3.6 0H12.5333C14.4 0 16 1.6 16 3.6V6.66667H13.3333H10.9333C8.8 6.66667 6.66667 8.8 6.66667 10.9333V13.3333Z" })]
	})
});
export { SvgSendBackwards as ReactComponent };
